import React, { useState } from 'react'

const TestimonialsNew = () => {

  const testimonialsData = [
    {
      name: "Yogesh Mewani",
      company: "Ganesha Construction",
      image:
        "https://storagereponeevaydevcdn.blob.core.windows.net/business/yogesh_mewani.svg",
      text:
        "Using Neevay portal has been a game-changer for my team. Neevay portal simplified our search for contractors, suppliers, manufacturers and labor contractors in different regions",
    },
    {
      name: "Gokul Tiwari",
      company: "AMP IMPEX",
      image:
        "https://storagereponeevaydevcdn.blob.core.windows.net/business/gokul_tiwari.svg",
      text:
        "As a steel seller on Neevay portal has really helped our business. Easy connections with buyers and a straightforward approach make it a valuable resource for any steel seller. Highly recommended!",
    },
    {
      name: "Megha Puranik",
      company: "Vascon Engineers",
      image:
        "https://storagereponeevaydevcdn.blob.core.windows.net/business/Testimonial_2.svg",
      text:
        "The platform's user-friendly interface and diverse options made our decision-making process smooth and stress-free. A valuable resource for anyone in the construction industry!",
    },
    // {
    //   name: "Jason Martin",
    //   company: "Sales Manager, Delta Materials Co.",
    //   image:
    //     "https://neevaywebapp.blob.core.windows.net/website/user_4.jpg",
    //   text:
    //     "We started getting quality RFQs from day one. Our quote-to-order ratio has jumped significantly.",
    // },
  ];

  const videos = [
    "https://www.youtube.com/embed/CVSIl14C4Qo",
    //   "https://www.youtube.com/embed/dQw4w9WgXcQ",
    //   "https://www.youtube.com/embed/ysz5S6PUM-U",
  ];

  const [current, setCurrent] = useState(0);

  const prevVideo = () => {
    setCurrent((prev) => (prev === 0 ? videos.length - 1 : prev - 1));
  };

  const nextVideo = () => {
    setCurrent((prev) => (prev === videos.length - 1 ? 0 : prev + 1));
  }

  return (
  <>
    <div>
      {/* <section className="bg-white pt-12 pb-12 px-8"> */}
        {/* <h2 className="text-4xl text-center font-semibold">
          Real Stories. Real Savings.
        </h2>

        <p className="mt-3 text-gray-500 text-center">
          Watch how builders and vendors use Neevay to save time,
          cut costs, and win more work
        </p> */}

        {/* <div className="flex items-center justify-center mt-10 gap-6"> */}

          {/* LEFT ARROW */}
          {/* <button
          onClick={prevVideo}
          aria-label="Previous video"
          className="p-3 rounded-full hover:bg-gray-100 transition"
        >
          <img
            src="https://storagereponeevaydevcdn.blob.core.windows.net/business/homepage4_left_arrow.svg"
            alt="previous"
            className="h-[23px] w-[10px]"
          />
        </button> */}

          {/* VIDEO */}
          {/* <iframe
            key={videos[current]}
            className="w-full max-w-[600px] h-[300px] rounded-lg bg-cover shadow-md"
            src={videos[current]}
            title="Neevay Story Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          /> */}

          {/* RIGHT ARROW */}
          {/* <button
          onClick={nextVideo}
          aria-label="Next video"
          className="p-3 rounded-full hover:bg-gray-100 transition"
        >
          <img
            src="https://storagereponeevaydevcdn.blob.core.windows.net/business/homepage4_right_arrow.svg"
            alt="next"
            className="h-[23px] w-[10px]"
          />
        </button> */}

        {/* </div> */}
      {/* </section> */}
      {/* TESTIMONIALS */}
      <section className="bg-[#ede6e633] py-16 px-8">
        <div className='max-w-6xl mx-auto'>
          <h2 className="text-4xl text-center font-semibold">
            What Our Users Are Saying
          </h2>

          <div className="my-8 lg:mx-24 grid md:grid-cols-3 gap-6">
            {testimonialsData.map((item, index) => (
              <div key={index} className="flex gap-6">
                <div className="py-6 border rounded-lg">
                  <div className='flex gap-x-4 pr-6'>
                    <div className='bg-orange-200 min-w-2 max-w-2 rounded-r-lg'></div>
                    <p className="text-sm">{item.text}</p>
                  </div>

                  <div className="flex mt-4 gap-x-4 px-6">
                    {/* FULLY CIRCULAR IMAGE */}
                    <img
                      className="w-12 h-12 rounded-full object-cover object-center flex-shrink-0"
                      src={item.image}
                      alt={item.name}
                    />

                    <div>
                      <h4 className="font-semibold">{item.name}</h4>
                      <p className="text-sm">{item.company}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  </>
  )
}

export default TestimonialsNew